export const GlobalConfig = {
    appName: "极客ABC",
};

export const EMAIL_ACTIONS = {
    REGISTER: 'register',
    RESET_PASSWORD: 'resetPassword'
}

export const EVENTS = {
    LOAD_NEXT_LESSON: 'load_next_lesson'
}
